const TYPE_ALERT = {
    UPDATE: 'Twoje dane zostały zaktualizowane',
    WRONG_CONNECT_DATABASE: 'Brak połączenia z bazą danych',
    SAVE: 'Twoje dane zostały zapisane',
    DELETED: 'Wybrane dane zostały usunięte',
    WRONG_DELETED: 'Niestety dane nie mogły zostać usunięte',
    WRONG_SAVE: 'Niestety dane nie mogły zostać zapisane',
    EXCEED_TEAM_EVENTS_LIMIT: 'Przekroczono zespołowy limit urlopów na ten termin',
    LOGIN: 'W naszym systemie',
    WRONG_LOGIN: 'Podałeś błędny login lub hasło',
    REGISTRATION: 'Rejestracja zakończyła się sukcesem',
    WRONG_REGISTRATION: 'Wybrany login lub email jest już zajęty',
    UPDATE_PASSWORD: 'Hasło zostało zaktualizowane',
    WRONG_UPDATE_PASSWORD: 'Zmiana hasła nie udana',
    NO_USER_SELECTED: 'Nie zaznaczono żadnego użytkownika, proszę wybrać z listy poniżej.',
    NO_YEAR_SELECTED: 'Nie wybrano roku.',
    WRONG_CONNECT_REPORT: 'Błąd połączenia z serwisem do generowania pdfów.',
    UNDEFINED_PROBLEM: 'Nieznany błąd',
    WRONG_FORMAT_FOR_PDF: 'Zły format danych',
    ERROR_ENTERING_DATA: 'Błąd przy wprowadzaniu danych',
    PLEASE_ENTER_DATA: 'Wprowadź dane',
    COULD_NOT_FIND_CURRENT_YEAR_DATA: 'Nie udało się znaleźć danych urlopowych na bieżący rok.',
    WRONG_DATES_RANGE: 'Wybrany okres jest niepoprawny',
};

export default TYPE_ALERT;



// WEBPACK FOOTER //
// ./src/constantValues/TYPE_ALERT.js